import styled from "styled-components";
import { sectionRhythm } from "../../../../theme";

//styles
export const PageSection = styled.section`
  max-width: 94%;
  margin: 0 auto;

  @media (min-width: 1280px) {
    max-width: min(94%, 1280px);
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);

  margin-inline: 1.5rem;
  gap: 1rem;
  padding-top: ${sectionRhythm.paddingY.mobile}px;
  padding-bottom: ${(props) =>
    sectionRhythm.paddingY.mobile +
    (props.$compensateHeaderGap
      ? sectionRhythm.headerHeight.mobile
      : 0)}px;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    padding-top: ${sectionRhythm.paddingY.desktop}px;
    padding-bottom: ${(props) =>
      sectionRhythm.paddingY.desktop +
      (props.$compensateHeaderGap
        ? sectionRhythm.headerHeight.desktop
        : 0)}px;
  }

  @media (min-width: 640px) {
    margin-inline: 2rem;
  }

  @media (min-width: 768px) {
    margin-inline: 3rem;
    gap: 1.5rem;
  }

  @media (min-width: 1024px) {
    margin-inline: 4rem;
  }

  @media (min-width: 1280px) {
    margin-inline: auto;
    width: 100%;
    max-width: 1280px;
    gap: 2rem;
  }
`;

export const SidebarColumn = styled.aside`
  grid-column: span 12;
  align-self: flex-start;
  min-width: 0;

  @media (min-width: 768px) {
    grid-column: span 4;
  }
`;

export const MainColumn = styled.main`
  grid-column: span 12;
  min-width: 0;

  @media (min-width: 768px) {
    grid-column: span 8;
  }
`;
